module.exports = __webpack_public_path__ + "static/media/NSCA_CSCS2.abbbd1ff.jpg";